import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enTranslations from '../i18n/en.json'
import deTranslations from '../i18n/de.json'

const i18nInstance = i18n.createInstance()

i18nInstance.init({
  resources: {
    en: { translation: enTranslations },
    de: { translation: deTranslations },
  },
  lng: 'de',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18nInstance
